import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Snackbar, makeStyles } from "@material-ui/core";
import {
  clear,
  setOpen,
  selectContent,
  selectOpen,
  selectLevel,
  selectTimeout,
} from "./snackAlertSlice";
import styles from "./SnackAlert.module.css";
import { selectLanguage } from "../language/languageSlice";
import MuiAlert from "@material-ui/lab/Alert";
function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}
const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
      width: "100%",
      "&:hover": {
        boxShadow: "0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)",
      },
      transition: "box-shadow 0.75s",
    },
  },
}));

export function SnackAlert() {
  const classes = useStyles();
  const content = useSelector(selectContent);
  const level = useSelector(selectLevel);
  const open = useSelector(selectOpen);
  const language = useSelector(selectLanguage);
  const timeOut = useSelector(selectTimeout);
  const dispatch = useDispatch();
  const handleClose = (e, r) => {
    if (r === "timeout" || r === "closebyclick") {
      //console.log("close");
      dispatch(setOpen(false));
    }
  };

  console.log("SnackAlert content:", content);

  return (
    <Snackbar
      open={open}
      autoHideDuration={timeOut || 3000}
      onClose={(e, r) => {
        handleClose(e, r);
      }}
    >
      <Alert
        onClose={(e) => {
          handleClose(e, "closebyclick");
        }}
        severity={level}
      >
        {typeof content === "string" ? content : JSON.stringify(content)}
      </Alert>
    </Snackbar>
  );
}
